// const baseUrl = 'https://crat-testnet-faucet.rocknblock.io/api/';
const baseUrl = 'https://faucet-testnet.cratd2csmartchain.io/api/';

export const walletGetMessageUrl = `${baseUrl}wallet/get_message/`;
export const walletConnectUrl = `${baseUrl}wallet/connect/`;
export const tokensUrl = `${baseUrl}tokens/`;
export const dayUserLimitUrl = `${baseUrl}day_user_limit/`;
export const totalDayLimitUrl = `${baseUrl}total_day_limit/`;
